export const FETCH_FEATURE_LIST_SUCCESSS = "FETCH_FEATURE_LIST_SUCCESSS";
export const PUT_FEATURE_SUCCESS = "PUT_FEATURE_SUCCESS";
export const GET_FEATURE_DETAIL_SUCCESS = "GET_FEATURE_DETAIL_SUCCESS";
